module.exports = __webpack_public_path__ + "img/icon-activity-type-image.457162f2.svg";